<template>
  <div style="height:100%">
    <div :class="this.isSupervisor ? 'task_filter1': 'task_filter'">
      <div class="task-filter__arrow-up"></div>

      <div class="task-filter__header">
          <h4>Filters    </h4>
      </div>
      <div class="task-filter__body">
        <div>
          <div class="row">
            <div class="col-md-12 form-group " style="padding-bottom:15px;">
              <div class="col-md-3" style="padding-right:5px;">
                <label>Created Date</label>
                <ob-date-time-picker ref="CreatedFromDate" v-model = "this.CreatedFromDate" class="offer-input" id="CreatedFromDate" placeholder="From date" :inputvalue="CreatedFromDate" :options="datePickerOptions" @updated="(v) => this.CreatedFromDate = v" :dpchange="onCreatedFrom"></ob-date-time-picker>
              </div>
              <div class="col-md-3 padding-left-0" style="margin-top: 5px;">
                <label></label>
                <ob-date-time-picker ref="CreatedToDate" class="offer-input" v-model = "this.CreatedToDate" id="CreatedToDate" placeholder="To date" :inputvalue="CreatedToDate" :options="datePickerOptions" @updated="(v) => this.CreatedToDate = v"></ob-date-time-picker>
              </div>
              <div class="col-md-6 pL0">
                <label>Created By</label>
                <ob-select2 v-if="showCreatedBy" :options="options" :inModal="true" v-model.trim="CreatedBy"></ob-select2>
              </div>
            </div>
          </div>
          <!-- <div class="row">
            <div class="col-md-12 form-group " style="padding-bottom:15px;">
              <div class="col-md-12" style="padding-right:5px;">
                <label>Evaluation Status</label>
                <div>
                  <div class="radio-inline pL0"><ob-radio name="options1" val="Pending" v-model="Status">Pending</ob-radio></div>
                  <div class="radio-inline pL0"><ob-radio name="options1" val="Completed" v-model="Status">Completed</ob-radio></div>
                </div>
              </div>
            </div>
          </div> -->
        </div>
        <div class="row task-filter__footer">
          <ob-button type="secondary" @click="cancelAppliedFilters">Cancel</ob-button>
          <ob-button type="primary" @click="applyFilter">Apply</ob-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props:["isSupervisor","showFilter"],
  data(){
    return{
      showCreatedBy: false,
      Status:'',
      CreatedFromDate:'',
      CreatedToDate:'',
      CreatedBy:'',
      datePickerOptions: {
        format: 'MM/DD/YYYY'
      },
      options: {
        placeholder: {
          id: "-1",
          text: "Select"
        },
        data: [
        ]
      }
    }
  },
  created(){
    events.listen('ClearingtheTaskFilteredData',()=>{
      this.clearFilteredData()
    })
  },
  watch:{
    showFilter(val){
      if(val == true){
        this.fetchCreatedByDetails()
      }
    }
  },
  computed:{
    EmployeeId() { // Handled For ESS and other users
      return this.$parent.$parent.EmployeeId;
    },
  },
  methods:{
    clearFilteredData(){
      //this.Status = '',
      this.CreatedFromDate = '',
      this.CreatedToDate = '',
      this.CreatedBy = ''
    },
    onCreatedFrom(e) {
      this.$refs.CreatedToDate.data.minDate(e.date)
    },
    cancelAppliedFilters(){
      this.$emit('cancel')
    },
    fetchCreatedByDetails()
    {
      this.$loading({
        'loadingText': 'Loading...'
      })
      this.showCreatedBy = false
        ajax.get(`/Task/${this.EmployeeId}/GetTaskCreatedDetails`,{},(res)=>{
        this.CreatedByList = res.data.UserDetails;
        this.options.data = __.map(res.data.UserDetails, (t) => {
          return { 'id': t.Id, 'text': t.FirstName +" "+ t.LastName  }
        })
        this.showCreatedBy = true
          this.$loading({}).close()
      })
    },
    applyFilter(){
      this.$parent.filter()
      var Obj =
      {
        FromDate : this.CreatedFromDate,
        ToDate : this.CreatedToDate,
        CreatedBy : this.findCreatedByName(this.CreatedBy),
        //Status : this.Status
      }
      this.$parent.$parent.fetchData(Obj)
      this.$emit('cancel')
    },
    findCreatedByName(id){
      let name = ''
      if(id) {
        let createdBy = __.find(this.options.data,function(createdBy){
          if(createdBy.id == id)
            return createdBy
        })
        name = createdBy.text
      }
      return name;
    }
  },
}
</script>
<style lang="scss" scoped>
@import "~styles/framework/bootstrap/variables";

.task_filter{
  background: $ob-white-color;
  position: relative;
  border: 1px solid $ob-light-gray-1;
  border-radius: 4px;
  -webkit-box-shadow: 0 2px 4px 0 $ob-filter-grey;
  -moz-box-shadow: 0 2px 4px 0 $ob-filter-grey;
  box-shadow: 0 2px 4px 0 $ob-filter-grey;
  position: absolute;
  top: 53px;
  left: 36px;
  width: 527px;
  z-index: 4;
  &:after, &:before{
    bottom: 100%;
    left: 52%;
    border: solid transparent;
    content: " ";
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
  }
  &:before {
    border-color: transparent;
    border-bottom-color: $ob-light-gray-1;
    border-width: 13px;
    margin-left: -13px;
  }
  &:after {
    border-color: rgba(255, 255, 255, 0);
    border-bottom-color: $ob-white-color;
    border-width: 12px;
    margin-left: -12px;
  }
  p{
    margin-bottom: 0;
  }
  h4 {
    color: $ob-brand-primary;
  }
  .task-filter__header {
    border-bottom: 1px solid $ob-light-gray-1;
    padding: 10px;
  }
  .task-filter__body {
    background: $ob-white-color;
    padding: 15px;
    max-height: 300px;
      .form-group{
      label{
        display: inline-block;
        max-width: 100%;
        margin-bottom: 5px;
        font-weight: 400;
      }
    }
  }
  .task-filter__footer {
    text-align: center;
    background: $ob-white-color;
    margin: 0;
    border-top: 1px solid $ob-light-gray-1;
    padding: 10px;
    button{
      margin: 0 5px;
    }
  }
}
.task_filter1{
  background: $ob-white-color;
  position: relative;
  border: 1px solid $ob-light-gray-1;
  border-radius: 4px;
  -webkit-box-shadow: 0 2px 4px 0 $ob-filter-grey;
  -moz-box-shadow: 0 2px 4px 0 $ob-filter-grey;
  box-shadow: 0 2px 4px 0 $ob-filter-grey;
  position: absolute;
  top: 184px;
  left: 58px;
  width: 527px;
  z-index: 4;
  &:after, &:before{
    bottom: 100%;
    left: 46%;
    border: solid transparent;
    content: " ";
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
  }
  &:before {
    border-color: transparent;
    border-bottom-color: $ob-light-gray-1;
    border-width: 13px;
    margin-left: -13px;
  }
  &:after {
    border-color: rgba(255, 255, 255, 0);
    border-bottom-color: $ob-white-color;
    border-width: 12px;
    margin-left: -12px;
  }
  p{
    margin-bottom: 0;
  }
  h4 {
    color: $ob-brand-primary;
  }
  .task-filter__header {
    border-bottom: 1px solid $ob-light-gray-1;
    padding: 10px;
  }
  .task-filter__body {
    background: $ob-white-color;
    padding: 15px;
    max-height: 300px;
      .form-group{
      label{
        display: inline-block;
        max-width: 100%;
        margin-bottom: 5px;
        font-weight: 400;
      }
    }
  }
  .task-filter__footer {
    text-align: center;
    background: $ob-white-color;
    margin: 0;
    border-top: 1px solid $ob-light-gray-1;
    padding: 10px;
    button{
      margin: 0 5px;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/ESSProfile/Tasks/TaskFilter.vue